// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3571": "bb0d7aea5624","4569": "63d2066c4163","5049": "0de64869a981",}[chunkId] + ".css"
}